import Button from "components/atoms/Button";
import InputField from "components/atoms/InputField";
import { useFormik } from "formik";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { errorToastNotif } from "utils/common";
import { PageMode, Source } from "utils/constant";
import React from "react";
import InputDate from "components/atoms/InputDate";
import BKKReporter from "services/BKKReporter";

const BKKReporterService = new BKKReporter();

const FormComponent = ({ selectedItem, pageMode, handlePageModeChange }) => {
  const { currentUser } = useSelector((state) => state.authReducer);

  const formik = useFormik({
    initialValues: {
      province_id: currentUser?.province_id,
      district_id: currentUser?.district_id,
      bkk_id: `${currentUser?.username}|${currentUser?.first_name}`,
      year: "",
      operator_name: "",
      phone_number: "",
      email: "",
    },
    validate: (values) => {
      const errors = {};
      if (!values.year) {
        errors.year = "Tahun wajib dipilih";
      }
      if (!values.operator_name) {
        errors.operator_name = "Nama petugas wajib diisi";
      }
      if (!values.phone_number) {
        errors.phone_number = "No Hp petugas wajib diisi";
      }
      if (!values.email) {
        errors.email = "Email petugas wajib diisi";
      }

      return errors;
    },
    onSubmit: async (values) => {
      const payload = {
        province_id: values.province_id,
        district_id: values.district_id,
        bkk_id: values.bkk_id,
        year: values.year,
        operator_name: values.operator_name,
        phone_number: values.phone_number,
        email: values.email,
      };

      switch (pageMode) {
        case PageMode.add:
          await BKKReporterService.add(payload)
            .then((res) => {
              handlePageModeChange(PageMode.view);
              toast.success("Data Dasar BKK berhasil ditambahkan", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                theme: "colored",
                draggable: true,
              });
            })
            .catch((err) => {
              errorToastNotif(err);
            });
          break;
        case PageMode.edit:
          await BKKReporterService.update(payload, selectedItem?.id)
            .then((res) => {
              handlePageModeChange(PageMode.view);
              toast.success("Data Dasar BKK berhasil diupdate", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                theme: "colored",
                draggable: true,
              });
            })
            .catch((err) => {
              console.log(err);
              errorToastNotif(err);
            });
          break;
      }
    },
  });

  useEffect(() => {
    if (pageMode === PageMode.edit) {
      formik.setValues({
        province_id: selectedItem.province_id,
        district_id: selectedItem.district_id,
        bkk_id: selectedItem.bkk_id,
        year: selectedItem.year,
        operator_name: selectedItem.operator_name,
        phone_number: selectedItem.phone_number,
        email: selectedItem.email,
      });
    }
  }, [selectedItem]);

  return (
    <>
      <h1 className="page-title">
        {pageMode === PageMode.add ? "Data Dasar BKK" : "Edit Data Dasar BKK"}
      </h1>

      <div className="form-grouping">
        <p
          className="warning"
          style={{ marginTop: "24px", marginBottom: "24px" }}
        >
          NOTE<span>*(WAJIB DIISI)</span>
        </p>

        <InputDate
          dateFormat={"YYYY"}
          label={"Tahun"}
          placeholder={"Pilih Tahun"}
          isRequired
          {...formik.getFieldProps("year")}
          error={formik.errors.year && formik.touched.year}
          errorMessage={formik.errors.year}
          value={formik.values.year}
          onChange={(e) => {
            const selectedDate = e ? moment(e).format("YYYY") : "";
            formik.setFieldValue("year", selectedDate);
          }}
          isDisabled={pageMode === PageMode.edit}
        />

        <InputField
          label={"Nama Petugas"}
          placeholder={"Masukkan nama petugas"}
          isRequired
          {...formik.getFieldProps("operator_name")}
          error={formik.errors.operator_name && formik.touched.operator_name}
          errorMessage={formik.errors.operator_name}
          value={formik.values.operator_name}
        />

        <InputField
          label={"No Telepon"}
          placeholder={"Masukkan no telepon"}
          type={"number"}
          isRequired
          {...formik.getFieldProps("phone_number")}
          error={formik.errors.phone_number && formik.touched.phone_number}
          errorMessage={formik.errors.phone_number}
          value={formik.values.phone_number}
        />

        <InputField
          label={"Email"}
          placeholder={"Masukkan email"}
          isRequired
          {...formik.getFieldProps("email")}
          error={formik.errors.email && formik.touched.email}
          errorMessage={formik.errors.email}
          value={formik.values.email}
        />

        {/* Action button */}
        <div className="button_action">
          <Button
            variant={"tertiary"}
            size={"normal"}
            onClick={() => handlePageModeChange(PageMode.view)}
          >
            Batalkan
          </Button>
          <Button
            type={"submit"}
            variant={"primary"}
            size={"normal"}
            onClick={formik.handleSubmit}
            isDisabled={
              formik.isSubmitting ||
              !formik.values.year ||
              !formik.values.operator_name ||
              !formik.values.phone_number ||
              !formik.values.email
            }
          >
            {pageMode === PageMode.edit ? "Ubah Data" : "Simpan Data"}
          </Button>
        </div>
      </div>
    </>
  );
};

export default FormComponent;
